import React, { useRef, useState } from 'react';

import { useFormik } from 'formik';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { surveyMakeDuplicate } from 'api/endpoints/survey';
import Button from 'components/Button';
import ErrorMessage from 'components/ErrorMessage';
import Input from 'components/Input';
import { ENUM_SURVEY_STATUS } from 'constants/enum';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { TEXT_COMMON, TEXT_VIEW_SURVEY } from 'constants/string/texts';
import { toastError, toastSuccess } from 'lib/toast';
import AppRoutes from 'routes/routes';
import { setLoading } from 'store/actions/common';

const Duplicate = (props) => {
  const { form, close, reloadData, onPageChange } = props;

  const navigator = useNavigate();

  const dispatch = useDispatch();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const modalDuplicateRef = useRef(null);

  const closeModal = () => {
    close();
  };

  const clickBackdrop = () => {
    modalDuplicateRef.current.classList.add('animate-fade-out');
    setTimeout(() => {
      modalDuplicateRef.current.classList.remove('animate-fade-out');
    }, 300);
  };

  const initialValues = {
    title: form.title,
  };

  const formDuplicate = useFormik({
    initialValues: initialValues,
    validateOnChange: isSubmitted,
    validateOnBlur: false,
    validate: (values) => {
      const errors = {};
      if (!values.title || values.title.trim() === '') errors.title = true;
      setIsSubmitted(true);
      return errors;
    },
    onSubmit: async (values) => {
      dispatch(setLoading({ isOpen: true }));
      await surveyMakeDuplicate(form.id, { ...values, status: ENUM_SURVEY_STATUS.DRAFT })
        .then(async (response) => {
          dispatch(setLoading({ isOpen: false }));
          toastSuccess(response?.message);
          closeModal();
          if (onPageChange) {
            const result = await onPageChange(1);
            if (!result) {
              if (reloadData) {
                await reloadData();
              } else {
                navigator(AppRoutes.survey);
              }
            }
          } else if (reloadData) {
            await reloadData();
          } else {
            navigator(AppRoutes.survey);
          }
          window.scrollTo(0, 0);
        })
        .catch((error) => {
          dispatch(setLoading({ isOpen: false }));
          toastError(error.message);
          closeModal();
        });
    },
  });

  return ReactDOM.createPortal(
    <div id="modal" className="fixed inset-0 flex-middle-center bg-gray-800 bg-opacity-50 z-50">
      <div onClick={clickBackdrop} className="fixed inset-0 backdrop" />

      <form onSubmit={formDuplicate.handleSubmit} ref={modalDuplicateRef} className="bg-white rounded-sm shadow-lg relative w-120 modal-content">
        <div className="flex-between-center px-6 py-4 ">
          <p className="font-bold">{TEXT_VIEW_SURVEY.DUPLICATE_TEXT}</p>
        </div>

        <div className="p-3 border-t border-white-720 h-30">
          <div className="max-h-138 w-full overflow-y-auto p-3 grid grid-cols-1">
            <p className="text-black opacity-85 w-full flex items-start gap-1 break-all mb-2">
              <img className="mt-2" src={require('assets/resources/Required.svg').default} alt="required" width={7} height={7} />
              {TEXT_VIEW_SURVEY.TITLE}
            </p>
            <Input
              value={formDuplicate?.values?.title}
              onChange={formDuplicate.handleChange}
              type="text"
              placeholder={''}
              className="w-full !h-10"
              classNameInput="!rounded-sm !w-108 !h-10 text-black opacity-85"
              name={'title'}
              invalid={(!formDuplicate.values.title || formDuplicate.errors.title) && isSubmitted}
              onKeyPress={(event) => {
                if (event.key === 'Enter') {
                  event.preventDefault();
                }
              }}
            />
            {(!formDuplicate.values.title || formDuplicate.errors.title) && isSubmitted && (
              <p className="text-sm text-danger-229 max-w-100">
                <ErrorMessage>{MESSAGE_COMMON.NOT_EMPTY}</ErrorMessage>
              </p>
            )}
          </div>
        </div>
        <div className="h-16 border-t border-white-720 flex-end-center gap-2 py-4 px-6">
          <Button className="h-8 text-sm w-25.5" text={TEXT_COMMON.CANCEL_TEXT} color="outline" onClick={closeModal} />
          <Button type="submit" className="h-8 text-sm w-30.5" text={TEXT_VIEW_SURVEY.CREATE_A_DUPLICATE} color="primary" />
        </div>
      </form>
    </div>,
    document.body
  );
};

export default React.memo(Duplicate);
